import React, { useState } from "react";

import AcessarMI from "components/layout/home/AcessarMI";
import FormBoletoRapido from "components/FormBoletoRapido";
import ResetPassword from "components/layout/home/AcessarMI/ResetPassword";
import StoreFront from "assets/icons/store.svg";
import { useLoginCarousel } from "features/login/hooks/useLoginCarousel";

import LoginBanners from "./LoginBanners";
import {
  AlignLogoMobile,
  AlignLogoWeb,
  Container,
  Content,
  ContentAlign,
  ContentAlignLogin,
  ContentAlignLogo,
  ContentImages,
  ContentLogin,
  ContentLoginWrapper,
  ContentLogo,
  ContentLogoMobile,
  DegradeDesktop,
  Image,
  ImageTextWrapper,
  Logo,
  TextLogoMobileWrapper,
  TextMobileWrapper,
  TextWeb,
  TextWebWrapper,
  TitleMobileWrapper,
  TitleWeb,
} from "./LoginPage.styles";

const LoginPage = (): JSX.Element => {
  const { active: imageActive, images } = useLoginCarousel();
  const [showModalResetPass, setShowModalRestPass] = useState(false);
  const showBoletoRapido = true;

  return (
    <>
      <Container>
        <DegradeDesktop />
        <Content>
          <ContentLogo>
            <Logo
              src="/static/ultragaz-logo-white-somando-energia.png"
              alt="Logo Ultragaz branca"
            />
            <ContentAlignLogo>
              <AlignLogoWeb>
                <TitleWeb>Portal Minha Ultragaz</TitleWeb>
                <TextWebWrapper>
                  <img
                    src={StoreFront}
                    alt="Portal Minha Ultragaz"
                    width={40}
                  />
                  <TextWeb>
                    Feito para moradores de condomínios e lojistas com medição
                    individualizada
                  </TextWeb>
                </TextWebWrapper>
              </AlignLogoWeb>
            </ContentAlignLogo>
          </ContentLogo>
          <ContentImages>
            {images.map((img, index) => (
              <Image
                key={img}
                src={img}
                alt="Portal Minha Ultragaz"
                isActive={index + 1 === imageActive}
              />
            ))}
          </ContentImages>
          <ContentLogin>
            <ContentAlign>
              <ContentLogoMobile>
                <AlignLogoMobile>
                  <TextLogoMobileWrapper>
                    <ImageTextWrapper>
                      <img
                        src={StoreFront}
                        alt="Portal Minha Ultragaz"
                        width={32}
                      />
                      <TitleMobileWrapper>
                        <h2>Portal</h2>
                        <h2>Minha Ultragaz</h2>
                      </TitleMobileWrapper>
                    </ImageTextWrapper>
                    <TextMobileWrapper>
                      <span>
                        Feito para moradores de condomínios e lojistas com
                      </span>
                      <span>medição individualizada</span>
                    </TextMobileWrapper>
                  </TextLogoMobileWrapper>
                </AlignLogoMobile>
              </ContentLogoMobile>
              <ContentLoginWrapper>
                <ContentAlignLogin>
                  <AcessarMI setShowModalRestPass={setShowModalRestPass} />
                </ContentAlignLogin>
                {showBoletoRapido && <FormBoletoRapido />}
              </ContentLoginWrapper>
            </ContentAlign>
          </ContentLogin>
        </Content>
      </Container>
      <LoginBanners />
      <ResetPassword
        setShowModal={setShowModalRestPass}
        showModal={showModalResetPass}
      />
    </>
  );
};

export default LoginPage;
